<template>
	<div class="today_table">
		<div class="tit_box">
			<a href="//table-m.cafe.daum.net" class="link_tit">
				<h3 class="tit_table">카페 안의 또 다른 놀이터!</h3>
				<span class="ico_arrow" />
			</a>
		</div>
		<div class="detail_box">
			<a :href="tableLinkUrl" class="link_detail">
				<div class="thumb_table">
					<img :src="tableImageUrl" class="thumb_img" alt="사용자 이미지" v-if="imageUrl">
				</div>
				<div class="cont_table">
					<strong class="tit_table">
						<span class="txt_tit">{{ name }}</span>
						<span class="txt_num">손님 {{ tableGuestCount }}</span>
					</strong>
					<p class="desc_table">{{ description }}</p>
				</div>
			</a>
			<div class="relate_detail"><strong class="screen_out">월간 인기글 리스트</strong>
				<ul class="list_relate">
					<li v-for="{tableId, postId, title, commentCount} in posts" :key="postId">
						<a :href="`//table-m.cafe.daum.net/p/${tableId}/${postId}`" class="link_item">
							<strong class="tit_item">{{ title }}</strong>
							<span class="txt_cmt">댓글 {{ formatCommentCount(commentCount) }}</span>
						</a>
					</li>
				</ul>
			</div>
		</div>
		<a :href="tableLinkUrl" class="link_more">
			<em class="emph_txt">{{ postCount.toLocaleString() }}개의</em> 이야기 더보기
		</a>
	</div>
</template>

<script>
import axios from 'axios';
import {getThumbnailUrl} from '@src/utils';

const MAX_COMMENT_COUNT = 999;

export default {
	data() {
		return {
			tableId: '',
			name: '',
			description: '',
			imageUrl: '',
			guestCount: 0,
			postCount: 0,
			posts: []
		};
	},
	computed: {
		tableLinkUrl() {
			return `//table-m.cafe.daum.net/t/${this.tableId}`;
		},
		tableImageUrl() {
			return getThumbnailUrl(this.imageUrl, 98, 98, 'C');
		},
		tableGuestCount() {
			if (this.guestCount < 10000) {
				return this.guestCount.toLocaleString('ko-KR');
			}
			if (this.guestCount < 1000000) {
				return `${(Math.floor((this.guestCount * 10) / 10000) / 10).toFixed(1).replace(/\.0$/, '')}만`;
			}
			if (this.guestCount < 10000000) {
				return `${Math.floor(this.guestCount / 10000)}만`;
			}
			return '999만+';
		}
	},
	methods: {
		formatCommentCount(commentCount) {
			if (commentCount > MAX_COMMENT_COUNT) {
				return `${MAX_COMMENT_COUNT}+`;
			}

			return commentCount;
		}
	},
	async created() {
		try {
			const {data} = await axios.get('/table/delivery-popular-table-posts');
			const table = data.tables[0];

			this.tableId = table.tableId;
			this.name = table.tableName;
			this.description = table.tableDescription;
			this.imageUrl = table.tableImageUrl;
			this.guestCount = table.tableGuestCount;
			this.postCount = table.tablePostCount;
			this.posts = table.posts;
		} catch (e) {
		}
	}
}
</script>
